// extracted by mini-css-extract-plugin
export var footer = "_nd-5";
export var fulfillmentInput = "_nd-0";
export var shipDateInput = "_nd-1";
export var shipmentModal = "_nd-2";
export var shipmentModalContent = "_nd-3";
export var tableContainer = "_nd-4";